import {pxToRem} from '../../../../utills/pxToRem'

export const containerStyle = {
    mt: {base: pxToRem(15), lg: pxToRem(64)},
    padding: {base: `0 ${pxToRem(11)}`, lg: `0 ${pxToRem(45)} 0 0`},
    maxWidth: '100vw',
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    mb: {base: pxToRem(60), lg: pxToRem(80)}
}

export const pageHeadingStyle = {
    textAlign: {base: 'center', lg: 'initial'},
    mb: '0'
}

export const headingIconStyle = {
    color: 'cav_red',
    width: {base: pxToRem(230.23), lg: pxToRem(274)},
    height: {base: pxToRem(46), lg: pxToRem(54.7)}
}

export const tileGridStyle = {
    mt: {base: '0 !important', lg: '0 !important'},
    spacing: {base: pxToRem(15), lg: pxToRem(25)},
    templateColumns: {base: '1fr', lg: '38.271% 1fr'}
}

export const tileStyle = {
    display: 'flex',
    flexDir: 'column',
    layerStyle: 'cardBordered',
    p: {base: pxToRem(15), lg: `${pxToRem(23)} ${pxToRem(18)}`},
    gap: {base: pxToRem(10), lg: pxToRem(10)},
    boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} rgba(0, 0, 0, 0.25)`,
    textAlign: {base: 'center', lg: 'initial'},
    mt: '0 !important'
}

export const tileHeadingStyle = {
    fontFamily: 'Montserrat',
    fontSize: 'lg',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    mb: '0'
}

export const normalTextStyle = {
    fontSize: pxToRem(13),
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const rewardTileContainerStyle = {
    align: 'start',
    spacing: pxToRem(15)
}

export const rewardTileContentStyle = {
    spacing: pxToRem(25)
}

export const rewardTileIconTextStyle = {
    ...normalTextStyle,
    textAlign: 'center'
}

export const rewardTileItemContainerStyle = {
    spacing: pxToRem(10)
}

export const rewardTileIconStyle = {
    color: 'cav_red',
    height: pxToRem(56)
}

export const starRewardIconStyle = {
    width: pxToRem(58.69)
}

export const walletRewardIconStyle = {
    width: pxToRem(48.25)
}

export const pointsTileItemContainerStyle = {
    align: {base: 'center', lg: 'initial'},
    spacing: pxToRem(10)
}

export const pointsTileTextStyle = {
    ...normalTextStyle,
    alignSelf: 'start'
}

export const pointsTilePointsStyle = (isZero = false) => ({
    fontSize: pxToRem(38.571),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(6.429),
    textTransform: 'uppercase',
    alignSelf: 'start',
    mt: {base: `${pxToRem(10)} !important`, lg: `${pxToRem(isZero ? 10 : 20)} !important`}
})

export const progressbarStyle = {
    sx: {
        div: {
            bgColor: 'cav_red'
        }
    },
    width: 'full'
}

export const pointsTileExpiryTextStyle = {
    ...normalTextStyle,
    alignSelf: 'start',
    color: 'cav_light_input_gray'
}

export const myRewardsTextStyle = {
    ...normalTextStyle,
    mt: '0 !important',
    mb: '5px !important'
}

export const benefitsTileGridStyle = {
    templateColumns: {base: '1fr', lg: '1fr 1fr 1fr'},
    gap: {base: pxToRem(15), lg: pxToRem(40)}
}

export const benefitsItemContainerStyle = {
    spacing: {base: pxToRem(15), lg: pxToRem(10)}
}

export const benefitsIconsStyle = {
    width: {base: pxToRem(50), lg: pxToRem(50)},
    height: {base: pxToRem(56), lg: pxToRem(59)}
}

export const benefitsIconTextStyle = {
    ...normalTextStyle
}

export const summaryContainerStyle = {
    mt: `${pxToRem(15)} !important`
}

export const summaryTextStyle = {
    ...normalTextStyle,
    textAlign: 'center'
}

export const summaryLinkTextStyle = {
    color: 'cav_red',
    textDecoration: 'underline'
}

// sx reward Styles
export const rewardFullTileStyle = {
    ...tileStyle,
    '.reward-tile': {
        display: 'flex',
        flexDirection: 'column'
    },
    '.tile-heading': {
        ...tileHeadingStyle
    },
    '.tile-body': {
        display: 'flex',
        mt: pxToRem(15),
        ...rewardTileItemContainerStyle,
        p: {
            ...rewardTileIconTextStyle,
            mt: pxToRem(10)
        },
        '.content-1': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            svg: {
                ...rewardTileIconStyle,
                ...walletRewardIconStyle
            }
        },
        '.content-2': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            ml: pxToRem(25),
            svg: {
                ...rewardTileIconStyle,
                ...starRewardIconStyle
            }
        }
    }
}

// sx benefits styles
export const benefitsFullTileStyle = {
    ...tileStyle,
    '.benefits-tile': {
        display: 'flex',
        flexDirection: 'column'
    },
    '.tile-heading': {
        ...tileHeadingStyle
    },
    '.tile-body': {
        display: 'grid',
        mt: pxToRem(25),
        gridTemplateColumns: {base: '1fr', lg: '1fr 1fr 1fr'},
        gridGap: {base: pxToRem(15), lg: pxToRem(40)},
        '.content-1,.content-2,.content-3': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        svg: {
            width: {base: `${pxToRem(50)} !important`, lg: `${pxToRem(50)} !important`},
            minWidth: {base: `${pxToRem(50)} !important`, lg: `${pxToRem(50)} !important`},
            height: {base: `${pxToRem(56)} !important`, lg: `${pxToRem(59)} !important`},
            minHeight: {base: `${pxToRem(56)} !important`, lg: `${pxToRem(59)} !important`}
        },
        p: {
            ...benefitsIconTextStyle,
            mb: '0',
            ml: {base: pxToRem(15), lg: pxToRem(10)}
        }
    }
}

// sx additional info
export const additionalInfoFullTileStyle = {
    ...summaryContainerStyle,
    p: {
        ...summaryTextStyle
    },
    a: {
        ...summaryLinkTextStyle
    }
}

export const couponModalStyle = {
    borderRadius: '18.784px'
}

// Swiper
export const swiperContainerStyle = (onlyOne = false) => ({
    margin: {base: '0 -15px !important', lg: '0 -18px !important'},
    width: {base: 'calc(100% + 30px)', lg: 'calc(100% + 36px)'},
    paddingLeft: {base: '15px', lg: '18px'},
    '.swiper-initialized': {
        paddingRight: {base: '15px', lg: '18px'}
    },
    '.swiper-wrapper': {
        justifyContent: onlyOne ? {base: 'center', lg: 'initial'} : 'initial'
    },
    '.swiper-button-prev,.swiper-button-next': {
        bg: 'gray.500',
        width: {base: '30px', lg: '40px'},
        height: {base: '30px', lg: '40px'},
        borderRadius: '50%',
        cursor: 'pointer',
        _after: {
            fontSize: {base: '14px', lg: '20px'},
            color: 'white',
            fontWeight: 'semibold'
        },
        _disabled: {
            display: 'none'
        },
        _hover: {
            bg: 'transparent',
            _after: {
                color: 'black'
            }
        }
    }
})

export const shopNowButtonStyle = {
    maxWidth: pxToRem(295)
}
